var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArtistFill = function SvgArtistFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 20q-1.05 0-1.775-.725T15 17.5t.725-1.775T17.5 15q.2 0 .45.037.25.038.55.163V11q0-.424.288-.713A.97.97 0 0 1 19.5 10H21q.424 0 .712.287.288.288.288.713 0 .424-.288.713A.97.97 0 0 1 21 12h-1v5.5q0 1.05-.725 1.775T17.5 20M11 12q-1.65 0-2.825-1.175T7 8t1.175-2.825T11 4t2.825 1.175T15 8t-1.175 2.825T11 12m-8 7v-1.8q0-.875.438-1.575.437-.7 1.162-1.075a14.8 14.8 0 0 1 3.15-1.163 13.8 13.8 0 0 1 5.338-.225q1.037.163 2.087.488-1.65 1-2.05 2.862t.65 3.488H4a.97.97 0 0 1-.712-.288A.97.97 0 0 1 3 19"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArtistFill);
export { ForwardRef as ReactComponent };